export const layoutManager = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_SYSTEM_ERROR_PAGE_OPEN: 'openErrorPage',
        LAYOUT_PAGEID_CHANGE: 'switchingLayout',
        LAYOUT_RELOAD: 'scrollPositioning',
        LAYOUT_SIDEBAR_CLOSE: 'closeSidebar',
        LAYOUT_MODAL_CLOSE: 'closeModal',
        LAYOUT_GAME_MODAL_OPEN: 'openGameModal',
        LAYOUT_GAME_MODAL_CLOSE: 'closeGameModal',
        LAYOUT_VIDEO_MODAL_CLOSE: 'closeVideoModal',
      },
    },
    switchingLayout: {
      initial: 'active',
      states: {
        active: {
          invoke: {
            src: 'pageIdToLayoutChange',
            onDone: {
              target: '#root.main.layoutManager.scrollPositioning',
              actions: [
                {
                  type: 'save',
                  data: {
                    navigationLinks: '$event.data.navigationLinks',
                    isSidebarInLayout: '$event.data.isSidebarInLayout',
                    isVideoEnabled: '$event.data.isVideoEnabled',
                    pageTitle: '$event.data.pageTitle',
                    pageMainTitle: '$event.data.pageMainTitle',
                    mainLayoutPath: '$event.data.mainLayoutPath',
                    controllersData: '$event.data.controllersData',
                    currentTablesIdList: '$event.data.currentTablesIdList',
                    updates: '$event.data.updates',
                    initialRequest: false,
                    segments: '$event.data.segments',
                    personalizedBanners: '$event.data.personalizedBanners',
                    gameLaunchStrategies: '$event.data.gameLaunchStrategies',
                    gameCloseStrategies: '$event.data.gameCloseStrategies',
                    isErrorPage: '$event.data.isErrorPage',
                    changePageAction: '',
                    searchBarComponent: '$event.data.searchBarComponent',
                    floatingIconComponent: '$event.data.floatingIconComponent',
                    idlePopupComponent: '$event.data.idlePopupComponent',
                    jackpotBetWidgetComponent:
                      '$event.data.jackpotBetWidgetComponent',
                    userStatusForCurrentPage:
                      '$event.data.userStatusForCurrentPage',
                  },
                  meta: {
                    selectors: [
                      '$action.data.navigationLinks',
                      '$action.data.isSidebarInLayout',
                      '$action.data.isVideoEnabled',
                      '$action.data.pageTitle',
                      '$action.data.pageMainTitle',
                      '$action.data.mainLayoutPath',
                      '$action.data.controllersData',
                      '$action.data.currentTablesIdList',
                      '$action.data.updates',
                      '$action.data.segments',
                      '$action.data.personalizedBanners',
                      '$action.data.gameLaunchStrategies',
                      '$action.data.gameCloseStrategies',
                      '$action.data.isErrorPage',
                      '$action.data.searchBarComponent',
                      '$action.data.floatingIconComponent',
                      '$action.data.idlePopupComponent',
                      '$action.data.jackpotBetWidgetComponent',
                      '$action.data.userStatusForCurrentPage',
                    ],
                  },
                },
                {
                  type: 'batchLayoutOperations',
                  data: '$event.data.updates',
                  meta: {
                    selectors: ['$action.data'],
                  },
                },
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path:
                          'components.ContentWrapper.properties.isSidebarInLayout',
                        value: '$context.isSidebarInLayout',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Layout.properties.deviceNative',
                        value: '$context.deviceInfo.isNative',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Layout.properties.deviceType',
                        value: '$context.deviceInfo.deviceType',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Layout.properties.deviceOs',
                        value: '$context.deviceInfo.deviceOs',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Layout.properties.launchStrategies',
                        value: '$context.gameLaunchStrategies',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Layout.properties.loggedIn',
                        value: '$context.user.loggedIn',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Modal.properties.componentVisible',
                        value: '$context.isSidebarInLayout',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                },
                'updateSiteTrackingStorageInfo',
                'updateRegistrationComponentMode',
                'trackPageChange',
                'updateSeo',
                'saveSegments',
              ],
            },
          },
          on: {
            LAYOUT_EXIT_CHANGE: { target: 'done' },
          },
        },
        done: {
          type: 'exit',
        },
      },
      exit: 'layout_notifyChangeEnd',
    },
    scrollPositioning: {
      always: [
        {
          actions: ['restoreScrollPosition', 'clearScrollRestore'],
          target: 'idle',
          cond: 'requiresScrollRestore',
        },
        {
          target: 'idle',
          cond: 'isSidebarVisibleOnBigScreen',
          actions: 'setBodyNonScrollable',
        },
        {
          target: 'idle',
          cond: 'isMobile',
        },
        {
          actions: ['scrollTop'],
          target: 'idle',
        },
      ],
    },
    closeSidebar: {
      entry: [
        {
          type: 'setLayoutProperty',
          data: {
            path: 'components.Modal.properties',
            value: {
              componentVisible: false,
              backButtonVisible: false,
            },
          },
        },
        {
          type: 'setLayoutProperty',
          data: {
            path: 'components.ContentWrapper.properties',
            value: {
              isSidebarInLayout: false,
            },
          },
        },
        {
          type: 'save',
          data: {
            isSidebarInLayout: false,
          },
        },
        'updateSiteTrackingStorageInfo',
        'updateRegistrationComponentMode',
        'tracking_changePage',
        'updateSeo',
        'layout_changePageId',
      ],
      always: 'idle',
    },
    closeModal: {
      entry: [
        {
          type: 'setLayoutProperty',
          data: {
            path: 'components.GameDetailsModal.properties',
            value: {
              componentVisible: false,
            },
          },
        },
        'updateSiteTrackingStorageInfo',
        'updateRegistrationComponentMode',
        'tracking_changePage',
        'updateSeo',
        'layout_changePageId',
      ],
      always: 'idle',
    },
    openGameModal: {
      entry: [
        {
          type: 'batchLayoutOperations',
          data: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Modal.properties.componentVisible',
                value: false,
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.GameDetailsModal.properties.componentVisible',
                value: false,
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Layout.properties.gameModalOpen',
                value: true,
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.GameModal.properties.visible',
                value: true,
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
          ],
        },
        'clearSearch_trigger',
        'updateGameLaunchedTracking',
      ],
      always: 'idle',
    },
    closeVideoModal: {
      entry: [
        {
          type: 'save',
          data: {
            changePageAction: 'BACK',
          },
        },
        {
          type: 'setLayoutProperty',
          data: {
            path: 'components.VideoModal.properties.visible',
            value: false,
          },
          meta: {
            selectors: ['$action.data.value'],
          },
        },
        'updateSiteTrackingStorageInfo',
        'updateRegistrationComponentMode',
        'tracking_changePage',
        'updateSeo',
        'layout_changePageId',
      ],
      always: 'idle',
    },
    closeGameModal: {
      entry: [
        {
          type: 'save',
          data: {
            isGameModalForMobileOpened: false,
          },
        },
        {
          type: 'save',
          data: {
            changePageAction: 'BACK',
          },
        },
        {
          type: 'batchLayoutOperations',
          data: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.GameModal.properties.visible',
                value: false,
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Layout.properties.gameModalOpen',
                value: false,
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.GameModal.properties.game',
                value: {},
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
          ],
        },
        'resetGameLaunchedTracking',
      ],
      always: 'idle',
    },
    openErrorPage: {
      invoke: {
        src: 'getErrorPage',
        onDone: {
          target: 'idle',
          actions: [
            {
              type: 'batchLayoutOperations',
              data: '$event.data.updates',
              meta: {
                selectors: ['$action.data'],
              },
            },
          ],
        },
      },
    },
  },
};
